import template from './avatar.html';
import controller from './avatar.controller';
import './avatar.scss';

/**
 * @param sizeBig makes the component with dimensions 80px instead of default 40px
 */
let avatarComponent = {
  restrict: 'E',
  bindings: {
    source: '<',
    name: '<',
    sizeBig: '@',
    email: '<',
    userId: '<',
    bbvaUId: '<',
    mediumSize: '@'
  },
  template,
  controller
};

export default avatarComponent;



// WEBPACK FOOTER //
// ./client/app/components/avatar/avatar.component.js